package com.parmartechnologies.core.feature.businessConnection.network

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@Serializable
data class BusinessConnectionRetrieveRequest(
    @SerialName("business_id") val BusinessID: String,
    @SerialName("user_id") val UserID: String,
)

@Serializable
data class BusinessConnectionCreateRequest(
    @SerialName("from_user_id") val fromUserID: String,
    @SerialName("from_business_id") val fromBusinessID: String,
    @SerialName("to_user_id") val toUserID: String,
    @SerialName("to_business_id") val toBusinessID: String,
    @SerialName("name") val name: String,
)